<template>
    <section class="article">
        <div class="layout-banner">
            <div class="banner">
                <div class="banner-text w-1200">
                    <div class="big-text">新 / 闻 / 资 / 讯</div>
                    <!-- <div class="sm-text">须臾此间，精彩呈现</div> -->
                    <div class="e-text">NEWS INFORMATION</div>
                </div>
            </div>
            <Nav :activeIndex='""'></Nav>
        </div>
        <div class="article-content w-1200">
            <div class="return-bar">
                <el-button type="text" @click="$router.push('/newsList')"><i class="el-icon-arrow-left"></i>返回新闻资讯列表</el-button>
            </div>
            <div>
                <h2 class="detail-title">{{articleList[id].title}}</h2>
                <p class="detail-pub-time">发布：{{articleList[id].time}} <span class="ml20">来源：{{articleList[id].source}}</span></p>
                <div class="detail-text-content" v-html="articleList[id].content">
                </div>
            </div>
        </div>
        <Footer></Footer>
        <Cornerbar></Cornerbar>
    </section>
</template>

<script>
import Nav from '@/components/Nav'
import Footer from '@/components/Footer'
import Cornerbar from '@/components/Cornerbar'
import articleJson from '@/http/data/news.json'
export default {
  components: {
    Nav,
    Footer,
    Cornerbar
  },
  data () {
    return {
      id: '',
      articleList: []
    }
  },
  created () {
    this.id = this.$route.query.id
    this.articleList = JSON.parse(JSON.stringify(articleJson.data))
  }
}
</script>

<style lang="scss" rel="stylesheet/scss">
@import "~@/styles/variable.scss";
.article{
    .layout-banner{
        position: relative;
        height: 350px;
    }
    .banner{
        background: url(../../assets/banner7.png) 100% no-repeat;
        // transition: all 7.6s cubic-bezier(0.04, 0.79, 1, 1) !important;
        // transform: scale(1.02);
        position: absolute;
        top: 0;
        width: 100%;
        height: 350px;
        overflow: hidden;
        background-repeat: no-repeat;
        background-position: center center;
        background-color: #0b0f1a;
        .banner-text{
            font-family: 'SourceHanSansCN-Regular';
            margin: 0 auto;
            padding-top: 150px;
            animation-duration: 2.5s;
            text-align: center;
            .big-text{
                color: #fff;
                height: 67px;
                font-size: 30px;
                line-height: 67px;
                letter-spacing: 1px;
            }
            .sm-text{
                line-height: 30px;
                font-size: 16px;
                letter-spacing: 1px;
                color: #fff;
            }
            .e-text{
                font-size: 42px;
                letter-spacing: 1px;
                color: #fff;
                font-family: Arial, Helvetica, sans-serif;
                opacity: 0.4;
            }
        }
    }
    .article-content{
        padding: 20px;
        margin: 0 auto;
        overflow: hidden;
        .return-bar {
            margin: 5px auto 15px 0;
            font-size: 14px;
            line-height: 20px;
            cursor: pointer;
        }
        h2.detail-title {
            font-size: 28px;
            font-weight: 400;
            color: #333333;
            margin: 0;
        }
        .detail-pub-time {
            margin-top: 9px;
            font-size: 14px;
            font-weight: 300;
            color: #74778b;
        }
        .detail-text-content {
            margin-top: 13px;
            margin-bottom: 70px;
            font-size: 16px;
            color: #74778b;
            line-height: 28px;
        }
    }
    .article-p{
        text-indent: 2em;
        margin-bottom: 28px;
    }
}
</style>
